<template>
	<div id="pageRoot">

		<span class="normalTheme pageInstruction" style="left: 40px; top: 155px">
			<p>Completa los espacios con la palabra adecuada:</p>
		</span>
		<p class="pageElement textBaseCourier" id="text03">
			PICHICHO / PERRO
		</p>
		<p class="pageElement textBaseCourier" id="text04">
			ALIMENTOS / MANJARES
		</p>
		<p class="pageElement textBaseCourier" id="text05">
			PELAJE / PELAMBRE
		</p>

		<div class="enciclopedia-half">
			<p class="textBaseCourier" id="text06">
				EL ______________ DOMÉSTICO ES UN MAMÍFERO CARNÍVORO. GRACIAS AL PROCESO DE DOMESTI- CACIÓN, EL ORGANISMO DEL PERRO SE HA ADAP- TADO A CIERTA CLASE DE __________________, EN ESTE CASO EL ALMIDÓN. SU TAMAÑO, FORMA Y ________________________ SON MUY DIVERSOS SEGÚN LA RAZA.
			</p>

			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02"/>
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03"/>

			<img id="imgDog" src="/pages/img/imgDog.jpg">
		</div>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<div clas="pageElement" id="fixedBackground"></div>
		<span class="footer-page footer-listen"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#fixedBackground
{
position: absolute;
width: 419px;
height: 156.02px;
left: 36px;
top: 40.95px;
background-image: url(/pages/img/sordo/svgPage89FixedBackground.svg);
z-index: -1;
}
#text01
{
position: absolute;
width: 594px;
height: 35px;
left: 78px;
top: 118px;

font-weight: normal;
font-size: 24px;
line-height: 33px;

color: #000000;
}
#text02
{
position: absolute;
width: 594px;
height: 35px;
left: 78px;
top: 168px;

font-weight: normal;
font-size: 24px;
line-height: 33px;

color: #000000;
}
#text03
{
position: absolute;
width: 426px;
height: 41px;
left: 84px;
top: 222px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text04
{
position: absolute;
width: 426px;
height: 41px;
left: 84px;
top: 272px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text05
{
position: absolute;
width: 426px;
height: 41px;
left: 84px;
top: 323px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text06
{
position: absolute;
width: 608px;
height: 297px;
left: 35px;
top: 62px;
 
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 190.28%;

color: #000000;
}
#imgDog
{	
position: absolute;
width: 241px;
height: 319px;
left: 684px;
top: 31px;
}
#inputField01
{
position: absolute;
width: 188px;
height: 31px;
left: 73px;
top: 51px;

background-color: white;
font-size: 26px;
z-index: 5;
}
#inputField02
{
position: absolute;
width: 261px;
height: 31px;
left: 365px;
top: 189px;

background-color: white;
font-size: 26px;
z-index: 5;
}
#inputField03
{
position: absolute;
width: 331px;
height: 31px;
left: 64px;
top: 278px;

background-color: white;
font-size: 26px;
z-index: 5;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p90/V122.mp4", "p90/V123.mp4", "p90/V124.mp4", "p90/V125.mp4", "p90/V126.mp4"]
    }
  }
}
</script>